import React, { forwardRef } from "react";
import DOMPurify from "dompurify";

// 26.10.2026 — güvenlik manifesti FE-P2-2: sunucudan gelen HTML (sözleşme içerikleri, operasyon raporları,
// KDV/sigorta notları, onay metinleri) ekrana basılmadan DOMPurify ile temizlenir. script, on* olayları,
// javascript: bağlantıları ve iframe düşer; biçim (style, tablo, liste, görsel) kalır. Yeni bir yerde HTML
// basılacaksa dangerouslySetInnerHTML yerine bu bileşen ya da temizHtml() kullanılmalı.

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  // Yeni sekmede açılan bağlantı açan sayfaya erişemesin
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") node.setAttribute("rel", "noopener noreferrer");
});

const AYAR = { ADD_ATTR: ["target"] };
// Web sitesi editörü önizlemesi: içerikteki video gömmeleri (iframe) görünsün; src yine DOMPurify URI kuralından geçer
const AYAR_IFRAME = { ADD_ATTR: ["target", "allow", "allowfullscreen", "frameborder"], ADD_TAGS: ["iframe"] };

/** HTML metnini temizler (boş/null → ""). iframe: true → iframe'e izin verir (yalnız editör önizlemesi). */
export function temizHtml(html, { iframe = false } = {}) {
  if (html === null || html === undefined || html === "") return "";
  return DOMPurify.sanitize(String(html), iframe ? AYAR_IFRAME : AYAR);
}

/** dangerouslySetInnerHTML için hazır nesne: {__html: temiz} */
export const temizMarkup = (html, secenek) => ({ __html: temizHtml(html, secenek) });

const SafeHtml = forwardRef(function SafeHtml({ html, as: Etiket = "div", ...props }, ref) {
  // eslint-disable-next-line react/no-danger
  return <Etiket ref={ref} {...props} dangerouslySetInnerHTML={temizMarkup(html)} />;
});

export default SafeHtml;
